import { NAME, EnumState } from "./constants";

const getModel = (state): EnumState => state.get(NAME);

export const createGetEnum = (enumName: string) => (state) => getModel(state).content[enumName] || [];

export const createIsEnumLoaded = (enumName: string) => (state) => !!getModel(state).content[enumName];
